import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

const RakLogo = () => (
  <svg width="160" height="36" viewBox="0 0 160 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="26" height="34" stroke="#FF914D" strokeWidth="1.5" fill="none"/>
    <rect x="5" y="5" width="18" height="26" stroke="#FF914D" strokeWidth="0.5" fill="none" opacity="0.3"/>
    <text x="6" y="27" fontFamily="Anton, sans-serif" fontSize="20" fill="#FF914D">R</text>
    <text x="38" y="16" fontFamily="Barlow, sans-serif" fontSize="10" fill="#F0EEE8" letterSpacing="3" fontWeight="400">RAK DIGITAL</text>
    <text x="38" y="30" fontFamily="Barlow, sans-serif" fontSize="7.5" fill="#7A9AB0" letterSpacing="4" fontWeight="300">DEVELOPMENTS</text>
  </svg>
);

const NAV_LINKS = [
  { label: 'Services', id: 'services' },
  { label: 'Projects', id: 'projects' },
  { label: 'About', id: 'about' },
  { label: 'Contact', id: 'contact' },
];

function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Box
      component="nav"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 3, md: 6 },
        height: '60px',
        background: scrolled ? 'rgba(13,24,33,0.97)' : 'rgba(13,24,33,0.92)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid #1E3040',
        transition: 'background 0.3s',
      }}
    >
      <Box
        component="a"
        href="/"
        sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
      >
        <RakLogo />
      </Box>

      <Box
        component="ul"
        sx={{
          display: { xs: 'none', md: 'flex' },
          gap: 4.5,
          listStyle: 'none',
          m: 0,
          p: 0,
        }}
      >
        {NAV_LINKS.map(({ label, id }) => (
          <Box
            component="li"
            key={id}
            onClick={() => scrollTo(id)}
            sx={{
              fontSize: '11px',
              letterSpacing: '3px',
              textTransform: 'uppercase',
              color: '#7A9AB0',
              cursor: 'pointer',
              fontFamily: "'Barlow', sans-serif",
              fontWeight: 300,
              transition: 'color 0.2s',
              '&:hover': { color: '#FF914D' },
            }}
          >
            {label}
          </Box>
        ))}
      </Box>

      <Box
        component="button"
        onClick={() => scrollTo('contact')}
        sx={{
          fontSize: '10px',
          letterSpacing: '2px',
          textTransform: 'uppercase',
          border: '1px solid #FF914D',
          color: '#FF914D',
          px: 2.5,
          py: 1,
          background: 'transparent',
          cursor: 'pointer',
          fontFamily: "'Barlow', sans-serif",
          fontWeight: 400,
          transition: 'all 0.2s',
          '&:hover': { background: '#FF914D', color: '#0D1821' },
        }}
      >
        Hire Me
      </Box>
    </Box>
  );
}

export default Navbar;
